import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ProducerScopeb3mmhvfa6ll7 as ProducerScope,
  produce3s4oh9balbl5b as produce,
} from '../../channels/Produce.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emitAll233y0vrwmloef as emitAll } from '../Channels.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope5mg03ltqqkp0 as coroutineScope,
} from '../../CoroutineScope.mjs';
import { BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance } from '../../channels/BufferOverflow.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CoroutineStart_ATOMIC_getInstance1xsp76269lswt as CoroutineStart_ATOMIC_getInstance } from '../../CoroutineStart.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from '../../Debug.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { SendingCollector33jb503i6hglm as SendingCollector } from './SendingCollector.mjs';
import { newCoroutineContext1x74axajiiptk as newCoroutineContext } from '../../CoroutineContext.mjs';
import { Key_instancesrycfl6s632h as Key_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { NopCollector2h4omm21qc7hq as NopCollector } from './NopCollector.mjs';
import { threadContextElements12yd4mfmaodla as threadContextElements } from '../../internal/ThreadContext.mjs';
import { startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn as startCoroutineUninterceptedOrReturnGeneratorVersion } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelFlow$_get_collectToFun_$slambda_j53z2eClass;
function ChannelFlow$_get_collectToFun_$slambda_j53z2e() {
  if (ChannelFlow$_get_collectToFun_$slambda_j53z2eClass === VOID) {
    class $ {
      constructor(this$0) {
        this.x1f_1 = this$0;
      }
      *y1f(it, $completion) {
        yield* this.x1f_1.f1d(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.y1f((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlow$_get_collectToFun_$slambda_j53z2eClass = $;
  }
  return ChannelFlow$_get_collectToFun_$slambda_j53z2eClass;
}
function ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this$0) {
  var i = new (ChannelFlow$_get_collectToFun_$slambda_j53z2e())(this$0);
  var l = (it, $completion) => i.y1f(it, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlow$collect$slambdaClass;
function ChannelFlow$collect$slambda() {
  if (ChannelFlow$collect$slambdaClass === VOID) {
    class $ {
      constructor($collector, this$0) {
        this.z1f_1 = $collector;
        this.a1g_1 = this$0;
      }
      *b1g($this$coroutineScope, $completion) {
        yield* emitAll(this.z1f_1, this.a1g_1.n1d($this$coroutineScope), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.b1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlow$collect$slambdaClass = $;
  }
  return ChannelFlow$collect$slambdaClass;
}
function ChannelFlow$collect$slambda_0($collector, this$0) {
  var i = new (ChannelFlow$collect$slambda())($collector, this$0);
  var l = ($this$coroutineScope, $completion) => i.b1g($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlowClass;
function ChannelFlow() {
  if (ChannelFlowClass === VOID) {
    class $ {
      constructor(context, capacity, onBufferOverflow) {
        this.g1d_1 = context;
        this.h1d_1 = capacity;
        this.i1d_1 = onBufferOverflow;
        // Inline function 'kotlinx.coroutines.assert' call
      }
      j1d() {
        return ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this);
      }
      k1d() {
        return this.h1d_1 === -3 ? -2 : this.h1d_1;
      }
      l1d(context, capacity, onBufferOverflow) {
        // Inline function 'kotlinx.coroutines.assert' call
        var newContext = context.rm(this.g1d_1);
        var newCapacity;
        var newOverflow;
        if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
          newCapacity = capacity;
          newOverflow = onBufferOverflow;
        } else {
          var tmp;
          if (this.h1d_1 === -3) {
            tmp = capacity;
          } else if (capacity === -3) {
            tmp = this.h1d_1;
          } else if (this.h1d_1 === -2) {
            tmp = capacity;
          } else if (capacity === -2) {
            tmp = this.h1d_1;
          } else {
            // Inline function 'kotlinx.coroutines.assert' call
            // Inline function 'kotlinx.coroutines.assert' call
            var sum = this.h1d_1 + capacity | 0;
            tmp = sum >= 0 ? sum : 2147483647;
          }
          newCapacity = tmp;
          newOverflow = this.i1d_1;
        }
        if (equals(newContext, this.g1d_1) && newCapacity === this.h1d_1 && newOverflow.equals(this.i1d_1))
          return this;
        return this.e1d(newContext, newCapacity, newOverflow);
      }
      n1d(scope) {
        return produce(scope, this.g1d_1, this.k1d(), this.i1d_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.j1d());
      }
      *z1c(collector, $completion) {
        return yield* coroutineScope(ChannelFlow$collect$slambda_0(collector, this), $completion);
      }
      o1d() {
        return null;
      }
      toString() {
        var props = ArrayList().h2(4);
        var tmp0_safe_receiver = this.o1d();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          props.i2(tmp0_safe_receiver);
        }
        if (!(this.g1d_1 === EmptyCoroutineContext_instance)) {
          props.i2('context=' + toString(this.g1d_1));
        }
        if (!(this.h1d_1 === -3)) {
          props.i2('capacity=' + this.h1d_1);
        }
        if (!this.i1d_1.equals(BufferOverflow_SUSPEND_getInstance())) {
          props.i2('onBufferOverflow=' + this.i1d_1.toString());
        }
        return get_classSimpleName(this) + '[' + joinToString(props, ', ') + ']';
      }
    }
    protoOf($).m1d = fuse$default;
    initMetadataForClass($, 'ChannelFlow', VOID, VOID, [FusibleFlow()], [1]);
    ChannelFlowClass = $;
  }
  return ChannelFlowClass;
}
function fuse$default(context, capacity, onBufferOverflow, $super) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? -3 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  return $super === VOID ? this.l1d(context, capacity, onBufferOverflow) : $super.l1d.call(this, context, capacity, onBufferOverflow);
}
var FusibleFlowClass;
function FusibleFlow() {
  if (FusibleFlowClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FusibleFlow', VOID, VOID, VOID, [1]);
    FusibleFlowClass = $;
  }
  return FusibleFlowClass;
}
var ChannelFlowOperatorImplClass;
function ChannelFlowOperatorImpl() {
  if (ChannelFlowOperatorImplClass === VOID) {
    class $ extends ChannelFlowOperator() {
      constructor(flow, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -3 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(flow, context, capacity, onBufferOverflow);
      }
      e1d(context, capacity, onBufferOverflow) {
        return new (ChannelFlowOperatorImpl())(this.j1g_1, context, capacity, onBufferOverflow);
      }
      *k1g(collector, $completion) {
        return yield* this.j1g_1.z1c(collector, $completion);
      }
    }
    initMetadataForClass($, 'ChannelFlowOperatorImpl', VOID, VOID, VOID, [1]);
    ChannelFlowOperatorImplClass = $;
  }
  return ChannelFlowOperatorImplClass;
}
function *collectWithContextUndispatched($this, collector, newContext, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.mc();
  var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
  return yield* withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda_0($this), $completion);
}
var ChannelFlowOperator$collectWithContextUndispatched$slambdaClass;
function ChannelFlowOperator$collectWithContextUndispatched$slambda() {
  if (ChannelFlowOperator$collectWithContextUndispatched$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.l1g_1 = this$0;
      }
      *m1g(it, $completion) {
        yield* this.l1g_1.k1g(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.m1g((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChannelFlowOperator$collectWithContextUndispatched$slambdaClass = $;
  }
  return ChannelFlowOperator$collectWithContextUndispatched$slambdaClass;
}
function ChannelFlowOperator$collectWithContextUndispatched$slambda_0(this$0) {
  var i = new (ChannelFlowOperator$collectWithContextUndispatched$slambda())(this$0);
  var l = (it, $completion) => i.m1g(it, $completion);
  l.$arity = 1;
  return l;
}
var ChannelFlowOperatorClass;
function ChannelFlowOperator() {
  if (ChannelFlowOperatorClass === VOID) {
    class $ extends ChannelFlow() {
      constructor(flow, context, capacity, onBufferOverflow) {
        super(context, capacity, onBufferOverflow);
        this.j1g_1 = flow;
      }
      *f1d(scope, $completion) {
        return yield* this.k1g(new (SendingCollector())(scope), $completion);
      }
      *z1c(collector, $completion) {
        if (this.h1d_1 === -3) {
          // Inline function 'kotlin.js.getCoroutineContext' call
          var collectContext = $completion.mc();
          var newContext = newCoroutineContext(collectContext, this.g1d_1);
          if (equals(newContext, collectContext))
            return yield* this.k1g(collector, $completion);
          if (equals(newContext.yc(Key_instance), collectContext.yc(Key_instance)))
            return yield* /*#__NOINLINE__*/collectWithContextUndispatched(this, collector, newContext, $completion);
        }
        yield* super.z1c(collector, $completion);
        return Unit_instance;
      }
      toString() {
        return toString(this.j1g_1) + ' -> ' + super.toString();
      }
    }
    initMetadataForClass($, 'ChannelFlowOperator', VOID, VOID, VOID, [1, 2]);
    ChannelFlowOperatorClass = $;
  }
  return ChannelFlowOperatorClass;
}
function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof SendingCollector()) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof NopCollector();
  }
  if (tmp_0) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (UndispatchedContextCollector())(_this__u8e3s4, emitContext);
  }
  return tmp;
}
function *withContextUndispatched(newContext, value, countOrElement, block, $completion) {
  countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
  // Inline function 'kotlinx.coroutines.withCoroutineContext' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var tmp0 = block;
    var tmp2 = value;
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    var completion = new (StackFrameContinuation())(uCont, newContext);
    return startCoroutineUninterceptedOrReturnGeneratorVersion(tmp0, tmp2, completion);
  };
}
var UndispatchedContextCollector$emitRef$slambdaClass;
function UndispatchedContextCollector$emitRef$slambda() {
  if (UndispatchedContextCollector$emitRef$slambdaClass === VOID) {
    class $ {
      constructor($downstream) {
        this.n1g_1 = $downstream;
      }
      *o1g(it, $completion) {
        yield* this.n1g_1.r1d(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1g(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UndispatchedContextCollector$emitRef$slambdaClass = $;
  }
  return UndispatchedContextCollector$emitRef$slambdaClass;
}
function UndispatchedContextCollector$emitRef$slambda_0($downstream) {
  var i = new (UndispatchedContextCollector$emitRef$slambda())($downstream);
  var l = (it, $completion) => i.o1g(it, $completion);
  l.$arity = 1;
  return l;
}
var UndispatchedContextCollectorClass;
function UndispatchedContextCollector() {
  if (UndispatchedContextCollectorClass === VOID) {
    class $ {
      constructor(downstream, emitContext) {
        this.p1g_1 = emitContext;
        this.q1g_1 = threadContextElements(this.p1g_1);
        var tmp = this;
        tmp.r1g_1 = UndispatchedContextCollector$emitRef$slambda_0(downstream);
      }
      *r1d(value, $completion) {
        return yield* /*#__NOINLINE__*/withContextUndispatched(this.p1g_1, value, this.q1g_1, this.r1g_1, $completion);
      }
    }
    initMetadataForClass($, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector()], [1]);
    UndispatchedContextCollectorClass = $;
  }
  return UndispatchedContextCollectorClass;
}
var StackFrameContinuationClass;
function StackFrameContinuation() {
  if (StackFrameContinuationClass === VOID) {
    class $ {
      constructor(uCont, context) {
        this.s1g_1 = uCont;
        this.t1g_1 = context;
      }
      mc() {
        return this.t1g_1;
      }
      oc(result) {
        this.s1g_1.oc(result);
      }
    }
    initMetadataForClass($, 'StackFrameContinuation', VOID, VOID, [Continuation()]);
    StackFrameContinuationClass = $;
  }
  return StackFrameContinuationClass;
}
//region block: exports
export {
  fuse$default as fuse$default20ez9dp5pjoz7,
  ChannelFlowOperatorImpl as ChannelFlowOperatorImpl3gjkp847e0ebc,
  ChannelFlow as ChannelFlowvdfy82kdxy2m,
  FusibleFlow as FusibleFlow2tgh9s2p1kryd,
};
//endregion

//# sourceMappingURL=ChannelFlow.mjs.map
